import { message } from 'antd';
import { openMcpOAuthPopup } from '../../utils/mcpOAuth';

export const DEFAULT_PARAMS_SCHEMA = JSON.stringify(
  { type: 'object', properties: {}, required: [] },
  null,
  2,
);

export const HTTP_AUTH_OPTIONS = [
  { value: 'none', label: 'None' },
  { value: 'api_key', label: 'API Key' },
  { value: 'bearer', label: 'Bearer token' },
];

export const MCP_AUTH_OPTIONS = [
  { value: 'auto', label: 'Automatic (recommended)' },
  { value: 'bearer', label: 'Bearer token' },
  { value: 'oauth_client_credentials', label: 'OAuth client credentials (advanced)' },
];

export const HTTP_METHODS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'].map((m) => ({ value: m, label: m }));

export function toolAuthLabel(authType) {
  const t = (authType || 'none').toLowerCase();
  if (t === 'oauth_authorization_code' || t === 'auto') return 'OAuth';
  if (t === 'bearer' || t === 'api_key' || t === 'oauth_client_credentials') return 'Token';
  return 'None';
}

export function buildHttpAuth(values) {
  const auth = { type: values.auth_type || 'none' };
  if (values.auth_type === 'bearer' && values.bearer_token) {
    auth.bearer_token = values.bearer_token;
  }
  if (values.auth_type === 'api_key' && values.api_key_value) {
    auth.api_key_value = values.api_key_value;
    auth.api_key_header = values.api_key_header || 'X-API-Key';
  }
  return auth;
}

export function buildMcpAuth(values) {
  if (values.bearer_token) {
    return { type: 'bearer', bearer_token: values.bearer_token };
  }
  if (values.auth_type === 'oauth_client_credentials') {
    return {
      type: 'oauth_client_credentials',
      client_id: values.client_id,
      token_url: values.token_url,
      client_secret: values.client_secret,
    };
  }
  return { type: 'auto' };
}

export function parseParametersSchema(text) {
  const schema = JSON.parse(text);
  if (typeof schema !== 'object' || schema === null) {
    throw new Error('Parameters schema must be a JSON object');
  }
  return schema;
}

export function handleMcpConnectResult(result, { onSuccess, openDetailId, onOAuthComplete } = {}) {
  if (result.status === 'oauth_required' && result.authorization_url) {
    openMcpOAuthPopup(result.authorization_url, {
      serverId: result.id,
      onClosedWithoutSuccess: onOAuthComplete,
    });
    if (openDetailId) openDetailId(result.id);
    return;
  }
  if (result.status === 'connected') {
    message.success(`Connected (${result.tool_count ?? 0} tools)`);
    onSuccess?.(result);
    return;
  }
  if (result.sync_error || result.message) {
    message.warning(result.sync_error || result.message);
  }
}
